import React, { useState, useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import "../../styles/styles.css";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  formatCurrency,
  formatterUSD,
} from "../../../../../commons/functions/generalFunctions";

const Image = (props) => {
  const { Imagen, estilo, estiloHover, currencySelect } = props;
  const [currencyValue, SetCurrencyValue] = useState(0);
  useEffect(() => {
    if (currencySelect.currency.currency === "USD") {
      SetCurrencyValue(currencySelect.currency.currencyLayer);
    } else {
      SetCurrencyValue(0);
    }
  }, [currencySelect]);
  return (
    <>
      <Link to={`/product/${Imagen.Idproduct}`}>
        <Paper
          className={estilo}
          style={{
            backgroundImage: `url(${Imagen.url})`,
          }}
        >
          <div className={estiloHover}>
            <h1 className="Textinfo customizableImage">
              {Imagen.code} {Imagen.name}
            </h1>
            <h1 className="Textinfoprice customizableImage">
              {!props.currencySelect || props.currencySelect.loading
                ? "Cargando..."
                : currencyValue === 0
                ? formatCurrency(Math.ceil(Imagen.price))
                : formatterUSD.format(
                    Math.ceil(Imagen.price / currencyValue.data.value) - 0.01
                  )}
            </h1>
          </div>
        </Paper>
      </Link>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    currencySelect: state.currencySelect,
  };
};

export default connect(mapStateToProps)(Image);
